

import * as THREE from "../libs/three.js/build/three.module.js";
import { Action } from "./Actions.js";
import { Utils } from "./utils.js";
import { EventDispatcher } from "./EventDispatcher.js";

export class Annotation extends EventDispatcher {
	constructor(args = {}) {
		super();

		this.scene = null;
		this._title = args.title || 'No Title';
		this._description = args.description || '';
		// 标注类型：用于按类型聚合与按类型样式（如 'camera' / 'device'）。不传即 'default'。
		this.type = args.type || 'default';
		this.offset = new THREE.Vector3();
		// 重构178 THREE.Math 迁移到 THREE.MathUtils（核心强制项）
		// this.uuid = THREE.Math.generateUUID();
		this.uuid = THREE.MathUtils.generateUUID();

		if (!args.position) {
			this.position = null;
		} else if (args.position.x != null) {
			this.position = args.position;
		} else {
			this.position = new THREE.Vector3(...args.position);
		}

		this.cameraPosition = (args.cameraPosition instanceof Array)
			? new THREE.Vector3().fromArray(args.cameraPosition) : args.cameraPosition;
		this.cameraTarget = (args.cameraTarget instanceof Array)
			? new THREE.Vector3().fromArray(args.cameraTarget) : args.cameraTarget;
		this.radius = args.radius;
		this.view = args.view || null;
		this.keepOpen = false;
		this.descriptionVisible = false;
		this.showDescription = true;
		this.actions = args.actions || [];
		this.isHighlighted = false;
		this._visible = true;
		this.__visible = true;
		this._display = true;
		this._expand = false;
		this.collapseThreshold = [args.collapseThreshold, 100].find(e => e !== undefined);

		this.children = [];
		this.parent = null;
		this.boundingBox = new THREE.Box3();
		// 包围盒脏标记：true 表示需要重算。默认脏，保证首次计算。
		// add/remove/offset 变更时向上标记父链；updateBounds 只重算脏子树。
		this._boundsDirty = true;

		let iconClose = exports.resourcePath + '/icons/close.svg';

		this._setDomElement($(`
			<div class="annotation" oncontextmenu="return false;">
				<div class="annotation-titlebar">
					<span class="annotation-label"></span>
				</div>
				<div class="annotation-description">
					<span class="annotation-description-close">
						<img src="${iconClose}" width="16px">
					</span>
					<span class="annotation-description-content">${this._description}</span>
				</div>
			</div>
		`));

		this.elTitlebar = this.domElement.find('.annotation-titlebar');
		this.elTitle = this.elTitlebar.find('.annotation-label');
		this.elTitle.append(this._title);
		this.elDescription = this.domElement.find('.annotation-description');
		this.elDescriptionClose = this.elDescription.find('.annotation-description-close');
		// this.elDescriptionContent = this.elDescription.find(".annotation-description-content");

		this.clickTitle = () => {
			if (this.hasView()) {
				this.moveHere(this.scene.getActiveCamera());
			}
			this.dispatchEvent({ type: 'click', target: this });
		};

		this.elTitle.click(this.clickTitle);

		this.actions = this.actions.map(a => {
			if (a instanceof Action) {
				return a;
			} else {
				return new Action(a);
			}
		});

		for (let action of this.actions) {
			action.pairWith(this);
		}

		let actions = this.actions.filter(
			a => a.showIn === undefined || a.showIn.includes('scene'));

		for (let action of actions) {
			let elButton = $(`<img src="${action.icon}" class="annotation-action-icon">`);
			this.elTitlebar.append(elButton);
			elButton.click(() => action.onclick({ annotation: this }));
		}

		this.elDescriptionClose.hover(
			e => this.elDescriptionClose.css('opacity', '1'),
			e => this.elDescriptionClose.css('opacity', '0.5')
		);
		this.elDescriptionClose.click(e => this.setHighlighted(false));
		// this.elDescriptionContent.html(this._description);

		this.domElement.mouseenter(e => this.setHighlighted(true));
		this.domElement.mouseleave(e => this.setHighlighted(false));

		this.domElement.on('touchstart', e => {
			this.setHighlighted(!this.isHighlighted);
		});

		this.display = false;
		//this.display = true;

	}

	installHandles(viewer) {
		if (this.handles !== undefined) {
			return;
		}

		let domElement = $(`
			<div style="position: absolute; left: 300; top: 200; pointer-events: none">
				<svg width="300" height="600">
					<line x1="0" y1="0" x2="1200" y2="200" style="stroke: black; stroke-width:2" />
					<circle cx="50" cy="50" r="4" stroke="black" stroke-width="2" fill="gray" />
					<circle cx="150" cy="50" r="4" stroke="black" stroke-width="2" fill="gray" />
				</svg>
			</div>
		`);

		let svg = domElement.find("svg")[0];
		let elLine = domElement.find("line")[0];
		let elStart = domElement.find("circle")[0];
		let elEnd = domElement.find("circle")[1];

		let setCoordinates = (start, end) => {
			elStart.setAttribute("cx", `${start.x}`);
			elStart.setAttribute("cy", `${start.y}`);

			elEnd.setAttribute("cx", `${end.x}`);
			elEnd.setAttribute("cy", `${end.y}`);

			elLine.setAttribute("x1", start.x);
			elLine.setAttribute("y1", start.y);
			elLine.setAttribute("x2", end.x);
			elLine.setAttribute("y2", end.y);

			let box = svg.getBBox();
			svg.setAttribute("width", `${box.width}`);
			svg.setAttribute("height", `${box.height}`);
			svg.setAttribute("viewBox", `${box.x} ${box.y} ${box.width} ${box.height}`);

			let ya = start.y - end.y;
			let xa = start.x - end.x;

			if (ya > 0) {
				start.y = start.y - ya;
			}
			if (xa > 0) {
				start.x = start.x - xa;
			}

			domElement.css("left", `${start.x}px`);
			domElement.css("top", `${start.y}px`);

		};

		$(viewer.renderArea).append(domElement);


		let annotationStartPos = this.position.clone();
		let annotationStartOffset = this.offset.clone();

		$(this.domElement).draggable({
			start: (event, ui) => {
				annotationStartPos = this.position.clone();
				annotationStartOffset = this.offset.clone();
				$(this.domElement).find(".annotation-titlebar").css("pointer-events", "none");

				console.log($(this.domElement).find(".annotation-titlebar"));
			},
			stop: () => {
				$(this.domElement).find(".annotation-titlebar").css("pointer-events", "");
			},
			drag: (event, ui) => {
				let renderAreaWidth = viewer.renderer.getSize(new THREE.Vector2()).width;

				let diff = {
					x: ui.originalPosition.left - ui.position.left,
					y: ui.originalPosition.top - ui.position.top
				};

				let nDiff = {
					x: -(diff.x / renderAreaWidth) * 2,
					y: (diff.y / renderAreaWidth) * 2
				};

				let camera = viewer.scene.getActiveCamera();
				let oldScreenPos = new THREE.Vector3()
					.addVectors(annotationStartPos, annotationStartOffset)
					.project(camera);

				let newScreenPos = oldScreenPos.clone();
				newScreenPos.x += nDiff.x;
				newScreenPos.y += nDiff.y;

				let newPos = newScreenPos.clone();
				newPos.unproject(camera);

				let newOffset = new THREE.Vector3().subVectors(newPos, this.position);
				this.offset.copy(newOffset);
				// 拖拽改变了 offset，标记包围盒为脏
				this.markBoundsDirty();
			}
		});

		let updateCallback = () => {
			let position = this.position;
			let scene = viewer.scene;

			const renderAreaSize = viewer.renderer.getSize(new THREE.Vector2());
			let renderAreaWidth = renderAreaSize.width;
			let renderAreaHeight = renderAreaSize.height;

			let start = this.position.clone();
			let end = new THREE.Vector3().addVectors(this.position, this.offset);

			let toScreen = (position) => {
				let camera = scene.getActiveCamera();
				let screenPos = new THREE.Vector3();

				let worldView = new THREE.Matrix4().multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
				let ndc = new THREE.Vector4(position.x, position.y, position.z, 1.0).applyMatrix4(worldView);
				// limit w to small positive value, in case position is behind the camera
				ndc.w = Math.max(ndc.w, 0.1);
				ndc.divideScalar(ndc.w);

				screenPos.copy(ndc);
				screenPos.x = renderAreaWidth * (screenPos.x + 1) / 2;
				screenPos.y = renderAreaHeight * (1 - (screenPos.y + 1) / 2);

				return screenPos;
			};

			start = toScreen(start);
			end = toScreen(end);

			setCoordinates(start, end);

		};

		viewer.addEventListener("update", updateCallback);

		this.handles = {
			domElement: domElement,
			setCoordinates: setCoordinates,
			updateCallback: updateCallback,
			viewer: viewer
		};
	}

	removeHandles(viewer) {
		if (this.handles === undefined) {
			return;
		}

		//$(viewer.renderArea).remove(this.handles.domElement);
		this.handles.domElement.remove();
		viewer.removeEventListener("update", this.handles.updateCallback);

		delete this.handles;
	}

	get visible() {
		return this._visible;
	}

	set visible(value) {
		if (this._visible === value) {
			return;
		}

		this._visible = value;

		//this.traverse(node => {
		//	node.display = value;
		//});

		this.dispatchEvent({
			type: 'visibility_changed',
			annotation: this
		});
	}

	// 唯一允许替换 domElement 的入口：赋值的同时把新元素的 DOM 显隐拉回与 _display 一致。
	//
	// 必须走这里的原因：构造函数末尾的 this.display = false 只对基类那个 .annotation 元素
	// 调了 hide()，而 AnnotationYd/Yd2/Yd3 随后把 domElement 整个换掉，新元素的根 class
	// (.yd-annotation-sxt / -sxt2 / -sxt3) 在 potree.css 里都没有 display 属性，于是用 UA
	// 默认的 display:block 显示出来 —— 此时 _display === false 但 DOM 可见，状态失同步。
	// 更糟的是 set display 有等值早退守卫，_display 已经是 false，后续任何
	// display = false 都会直接 return，hide() 永远走不到，原始图标就永久留在屏幕上
	// （聚合开启时表现为聚合圆圈与原始图标同时显示）。
	//
	// 新增子类若要替换 domElement，一律走这里，不要直接写 this.domElement。
	_setDomElement(el) {
		this.domElement = el;

		if (el) {
			if (this._display) {
				el.show();
			} else {
				el.hide();
			}
		}
	}

	get display() {
		return this._display;
	}

	set display(display) {
		if (this._display === display) {
			return;
		}

		this._display = display;

		// dispose() 会把 domElement 置空，但被移除的实例可能还留在 viewer.visibleAnnotations
		// 里，下一帧仍会被赋一次 display=false（见 viewer.updateAnnotations 的提交阶段）。
		// 这里判空避免 TypeError: Cannot read properties of null (reading 'hide')。
		if (!this.domElement) {
			return;
		}

		if (display) {
			// this.domElement.fadeIn(200);
			this.domElement.show();
		} else {
			// this.domElement.fadeOut(200);
			this.domElement.hide();
		}
	}

	get expand() {
		return this._expand;
	}

	set expand(expand) {
		if (this._expand === expand) {
			return;
		}

		if (expand) {
			this.display = false;
		} else {
			this.display = true;
			this.traverseDescendants(node => {
				node.display = false;
			});
		}

		this._expand = expand;
	}

	get title() {
		return this._title;
	}

	set title(title) {
		if (this._title === title) {
			return;
		}

		this._title = title;
		// dispose() 后 elTitle 为 null（AnnotationPanel 的 contenteditable 监听不会被拆掉，
		// 移除标注后仍可能触发一次），判空跳过 DOM 更新但保留字段与事件
		if (this.elTitle) {
			this.elTitle.empty();
			this.elTitle.append(this._title);
		}

		this.dispatchEvent({
			type: "annotation_changed",
			annotation: this,
		});
	}

	get description() {
		return this._description;
	}

	set description(description) {
		if (this._description === description) {
			return;
		}

		this._description = description;

		// 同 set title：dispose() 后 elDescription 为 null
		if (this.elDescription) {
			const elDescriptionContent = this.elDescription.find(".annotation-description-content");
			elDescriptionContent.empty();
			elDescriptionContent.append(this._description);
		}

		this.dispatchEvent({
			type: "annotation_changed",
			annotation: this,
		});
	}

	add(annotation) {
		if (!this.children.includes(annotation)) {
			this.children.push(annotation);
			annotation.parent = this;

			// 新子树加入，标记整条父链包围盒为脏
			this.markBoundsDirty();

			let descendants = [];
			annotation.traverse(a => { descendants.push(a); });

			for (let descendant of descendants) {
				let c = this;
				while (c !== null) {
					c.dispatchEvent({
						'type': 'annotation_added',
						'annotation': descendant
					});
					c = c.parent;
				}
			}
		}
	}

	level() {
		if (this.parent === null) {
			return 0;
		} else {
			return this.parent.level() + 1;
		}
	}

	hasChild(annotation) {
		return this.children.includes(annotation);
	}

	remove(annotation) {
		if (this.hasChild(annotation)) {
			// 先派发 annotation_removed（此刻引用仍完整，监听方还能读到 domElement/title），
			// 再 dispose。作用是让 viewer 把实例从 visibleAnnotations 里摘掉，否则 dispose
			// 后它仍留在集合里，下一帧被赋 display 时会撞上已置空的 domElement。
			// 只为 annotation 本身派发：下面的 removeAllChildren 会递归回 remove()，
			// 每个后代在自己那一层各派发一次，整棵子树恰好覆盖且不重复（父先子后）。
			let c = this;
			while (c !== null) {
				c.dispatchEvent({
					'type': 'annotation_removed',
					'annotation': annotation
				});
				c = c.parent;
			}

			annotation.removeAllChildren();
			annotation.dispose();
			this.children = this.children.filter(e => e !== annotation);
			annotation.parent = null;

			// 子树移除，标记整条父链包围盒为脏
			this.markBoundsDirty();
		}
	}

	removeAllChildren() {
		// 用 slice 复制，因为 remove 会修改 this.children
		for (let child of this.children.slice()) {
			this.remove(child);
		}
	}

	updateBounds() {
		// 非脏且无子节点变化时直接复用缓存的 boundingBox，避免每帧全树递归重算
		if (!this._boundsDirty) {
			return;
		}

		let box = new THREE.Box3();

		if (this.position) {
			box.expandByPoint(this.position);
		}

		for (let child of this.children) {
			child.updateBounds();

			box.union(child.boundingBox);
		}

		this.boundingBox.copy(box);
		this._boundsDirty = false;
	}

	// 标记自身及整条父链的包围盒为脏，供 add/remove/位置变更时调用
	markBoundsDirty() {
		let node = this;
		while (node !== null && !node._boundsDirty) {
			node._boundsDirty = true;
			node = node.parent;
		}
	}

	traverse(handler) {
		let expand = handler(this);

		if (expand === undefined || expand === true) {
			for (let child of this.children) {
				child.traverse(handler);
			}
		}
	}

	traverseDescendants(handler) {
		for (let child of this.children) {
			child.traverse(handler);
		}
	}

	flatten() {
		let annotations = [];

		this.traverse(annotation => {
			annotations.push(annotation);
		});

		return annotations;
	}

	descendants() {
		let annotations = [];

		this.traverse(annotation => {
			if (annotation !== this) {
				annotations.push(annotation);
			}
		});

		return annotations;
	}

	setHighlighted(highlighted) {
		// dispose() 会把 domElement / elTitlebar / elDescription 全部置空，而本方法是公开的、
		// 外部工具（AnnotationTool 等）可能在移除后仍调用一次，故先判空直接返回
		if (!this.domElement || !this.elTitlebar || !this.elDescription) {
			this.isHighlighted = highlighted;
			return;
		}

		if (highlighted) {
			this.domElement.css('opacity', '0.8');
			this.elTitlebar.css('box-shadow', '0 0 5px #fff');
			this.domElement.css('z-index', '1000');

			if (this._description) {
				this.descriptionVisible = true;
				this.elDescription.fadeIn(200);
				this.elDescription.css('position', 'relative');
			}
		} else {
			this.domElement.css('opacity', '0.5');
			this.elTitlebar.css('box-shadow', '');
			this.domElement.css('z-index', '100');
			this.descriptionVisible = false;
			this.elDescription.css('display', 'none');
		}

		this.isHighlighted = highlighted;
	}

	hasView() {
		let hasPosTargetView = this.cameraTarget && this.cameraTarget.x != null;
		hasPosTargetView = hasPosTargetView && this.cameraPosition.x != null;

		let hasRadiusView = this.radius !== undefined;

		let hasView = hasPosTargetView || hasRadiusView;

		return hasView;
	};

	moveHere(camera) {
		if (!this.hasView()) {
			return;
		}

		let view = this.scene.view;
		let animationDuration = 500;
		let easing = TWEEN.Easing.Quartic.Out;

		let endTarget;
		if (this.cameraTarget) {
			endTarget = this.cameraTarget;
		} else if (this.position) {
			endTarget = this.position;
		} else {
			endTarget = this.boundingBox.getCenter(new THREE.Vector3());
		}

		if (this.cameraPosition) {
			let endPosition = this.cameraPosition;

			Utils.moveTo(this.scene, endPosition, endTarget);
		} else if (this.radius) {
			let direction = view.direction;
			let endPosition = endTarget.clone().add(direction.multiplyScalar(-this.radius));
			let startRadius = view.radius;
			let endRadius = this.radius;

			{ // animate camera position
				let tween = new TWEEN.Tween(view.position).to(endPosition, animationDuration);
				tween.easing(easing);
				tween.start();
			}

			{ // animate radius
				let t = { x: 0 };

				let tween = new TWEEN.Tween(t)
					.to({ x: 1 }, animationDuration)
					.onUpdate(function () {
						view.radius = this.x * endRadius + (1 - this.x) * startRadius;
					});
				tween.easing(easing);
				tween.start();
			}
		}
	};

	dispose() {
		// 若装过 handles，完整移除（DOM + viewer 上的 update 监听），避免 update 回调泄漏后每帧执行死代码
		if (this.handles !== undefined) {
			this.removeHandles(this.handles.viewer);
		}

		// 解绑所有 jQuery 事件（click/mouseenter/mouseleave/touchstart/hover），
		// 避免 jQuery 内部 _data 缓存持有的监听器闭包（捕获 this=annotation）无法回收
		if (this.domElement) {
			this.domElement.off();
		}
		if (this.elTitle) {
			this.elTitle.off();
		}
		if (this.elDescriptionClose) {
			this.elDescriptionClose.off();
		}

		// 移除 DOM 节点（domElement 是 jQuery 对象，需取 [0] 拿原生节点）
		if (this.domElement && this.domElement[0] && this.domElement[0].parentElement) {
			this.domElement[0].parentElement.removeChild(this.domElement[0]);
		}

		// 清空 EventDispatcher 监听器，避免外部注册的回调闭包泄漏
		this._listeners = {};

		// 置空引用，帮助 GC
		// 先把 _display 复位成 false：dispose 后 DOM 已摘除，语义上就是"不显示"。
		// 这样后续过期的 display = false 会被 set display 的等值早退守卫吸收，
		// 连 domElement 判空都不必走到（判空是第二道防线）。
		this._display = false;
		this.domElement = null;
		this.elTitle = null;
		this.elTitlebar = null;
		this.elDescription = null;
		this.elDescriptionClose = null;
	};

	toString() {
		return 'Annotation: ' + this._title;
	}
};
